import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUser,
  faTimes,
  faPlusCircle,
  faPen,
  faTimesCircle,
  faUsers,
  faIdCard,
  faSave,
  faTrash,
  faSync,
  faCheckCircle,
  faInfoCircle,
  faDownload,
  faUpload,
  faCloudUploadAlt,
  faBan,
} from '@fortawesome/free-solid-svg-icons';
// import { far } from '@fortawesome/free-regular-svg-icons';
// import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faUser,
  faTimes,
  faPlusCircle,
  faPen,
  faTimesCircle,
  faUsers,
  faIdCard,
  faSave,
  faTrash,
  faSync,
  faCheckCircle,
  faInfoCircle,
  faDownload,
  faUpload,
  faCloudUploadAlt,
  faBan,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

export default {
  name: 'icons',
};
